import { createSimplePageStrategy } from './simple-page.strategy-helper';

export const FaqSeoStrategy = createSimplePageStrategy('faq', 'faq', '/faq');
